/* eslint-disable import/prefer-default-export */
import { keyframes } from 'styled-components';

export const slideAndFadeInLeft = value => keyframes`
0% {
  opacity: 0;
  transform: translateX(-${value});
}
100% {
  opacity: 1;
  transform: translateX(0);
}
`;

export const slideAndFadeInRight = value => keyframes`
  0% {
    opacity: 0;
    transform: translateX(${value});
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
